import {
  FETCH_ARTIST_HISTORY,
  MORE_ARTIST_HISTORY,
  UNLOAD_CURRENT_ARTIST,
} from '../actionTypes';
import { loadReducer } from './helpers';

export function artistHistory(state = null, action) {
  switch (action.type) {
    case FETCH_ARTIST_HISTORY:
      return loadReducer(state, action);
    case MORE_ARTIST_HISTORY:
      if (action.payload && !action.error && state.data) {
        return {
          ...state,
          data: {
            ...state.data,
            records: [
              ...(state.data.records || []),
              ...(action.payload.records || []),
            ],
            cursor: action.payload.cursor,
          },
        };
      }
      return state;
    case UNLOAD_CURRENT_ARTIST:
      return null;
    default:
      return state;
  }
}
